import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { z } from "zod";

import { useCompany } from "@/common/providers/company-provider";
import { CurrencyToType } from "@/generated/api/users";

type Currency = keyof typeof CurrencyToType;

const currencyEnum = z.enum([
  ...(Object.values(CurrencyToType) as [string, ...string[]]),
]);

const currencySchema = z.object({
  currency: currencyEnum,
});

const useCurrencyParams = () => {
  const [searchParams] = useSearchParams();
  const parsedParams = currencySchema.safeParse(
    Object.fromEntries(searchParams),
  );

  return {
    params: parsedParams.success ? parsedParams.data : undefined,
  };
};

const Params = ({ children }: React.PropsWithChildren) => {
  const { params } = useCurrencyParams();
  const { pathname } = useLocation();
  const company = useCompany();

  if (!params) {
    return (
      <Navigate
        replace
        to={{
          pathname,
          search: `currency=${company.country.currency}`,
        }}
      />
    );
  }

  return <>{children}</>;
};

export { currencyEnum, currencySchema, Params, useCurrencyParams };
export type { Currency };
